import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { createApi, formatApiError } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ namespace, children }) => {
  const api = useMemo(() => createApi(namespace), [namespace]);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const session = api.readSession();
    if (!session?.access_token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.client.get("/auth/me");
      setUser(data);
    } catch {
      api.clearSession();
      setUser(false);
    }
    setLoading(false);
  }, [api]);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (identifier, password) => {
    try {
      const { data } = await api.client.post("/auth/login", { identifier, password });
      api.writeSession(data);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) };
    }
  };

  const adoptSession = (data) => {
    api.writeSession(data);
    setUser(data.user);
  };

  const logout = async () => {
    try {
      await api.client.post("/auth/logout");
    } catch {
      /* sessão já inválida */
    }
    api.clearSession();
    setUser(false);
  };

  const forceSignOut = () => {
    api.clearSession();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ api: api.client, user, loading, login, logout, adoptSession, forceSignOut, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
